import { usePerformanceEffect } from './performance-effect.mjs';

function useLifecycleEventListener(listener) {
  usePerformanceEffect(performance => performance.on('lifecycleEvent', listener));
}

export { useLifecycleEventListener };
